import { Phone, MessageCircle, Navigation, MapPin, Mail } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { PHONE_DISPLAY, PHONE_TEL, wa, WA_MESSAGES, ADDRESS, MAPS_URL, MAPS_EMBED, EMAIL, EMAIL_MAILTO } from "@/lib/site";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHeading eyebrow="We'd Love to Hear From You" title="Connect With MAHIRA" />
        <div className="mt-16 grid gap-10 lg:grid-cols-2">
          <Reveal>
            <div className="flex h-full flex-col justify-between rounded-[28px] border border-forest/10 bg-white/70 p-8 backdrop-blur-md md:p-10">
              <div className="space-y-8">
                <div>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
                    Phone
                  </p>
                  <a
                    data-testid="contact-phone-link"
                    href={PHONE_TEL}
                    className="mt-2 block font-heading text-3xl text-forest transition-colors duration-300 hover:text-gold md:text-4xl"
                  >
                    {PHONE_DISPLAY}
                  </a>
                </div>
                <div>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
                    Email
                  </p>
                  <a
                    data-testid="contact-email-link"
                    href={EMAIL_MAILTO}
                    className="mt-2 flex items-center gap-3 font-heading text-2xl text-forest transition-colors duration-300 hover:text-gold"
                  >
                    <Mail className="h-5 w-5 shrink-0 text-forest/50" />
                    {EMAIL}
                  </a>
                </div>
                <div>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
                    Address
                  </p>
                  <p data-testid="contact-address" className="mt-2 flex items-start gap-3 text-base leading-relaxed text-charcoal/75">
                    <MapPin className="mt-1 h-5 w-5 shrink-0 text-forest/50" />
                    {ADDRESS}
                  </p>
                </div>
              </div>
              <div className="mt-10 flex flex-wrap gap-4">
                <a
                  data-testid="contact-call-button"
                  href={PHONE_TEL}
                  className="inline-flex items-center gap-2.5 rounded-full bg-forest px-7 py-3.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-ivory transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-forest-light"
                >
                  <Phone className="h-4 w-4" /> Call MAHIRA
                </a>
                <a
                  data-testid="contact-whatsapp-button"
                  href={wa(WA_MESSAGES.default)}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-7 py-3.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-white transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:brightness-95"
                >
                  <MessageCircle className="h-4 w-4" /> WhatsApp MAHIRA
                </a>
                <a
                  data-testid="contact-directions-button"
                  href={MAPS_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2.5 rounded-full border border-forest/25 px-7 py-3.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-forest transition-[background-color,border-color,transform] duration-300 hover:-translate-y-1 hover:border-gold hover:bg-gold/10"
                >
                  <Navigation className="h-4 w-4" /> Get Directions
                </a>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="h-full min-h-[380px] overflow-hidden rounded-[28px] border border-forest/10 shadow-[0_40px_90px_-40px_rgba(26,54,38,0.35)]">
              <iframe
                data-testid="contact-map"
                title="MAHIRA Agro Products location — Kharghar, Navi Mumbai"
                src={MAPS_EMBED}
                className="h-full min-h-[380px] w-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
